import React from 'react';

import { Button, ButtonWrapper, LoopedLoadingBar, SlideUpOverlay } from '@/core/features';

type TravelFormOverlayWrapperProps = {
    isLoading?: boolean;
    onClose: () => void;
    title: string;
} & (
    | {
          isCtaDisabled: boolean;
          isCtaHidden?: never;
          onSubmit: () => void;
          renderCtaText: React.ReactElement | string;
      }
    | {
          isCtaDisabled?: never;
          isCtaHidden: boolean;
          onSubmit?: never;
          renderCtaText?: never;
      }
);

export default function TravelFormOverlayWrapper({
    children,
    isCtaDisabled = false,
    isCtaHidden,
    isLoading,
    onClose,
    onSubmit,
    renderCtaText,
    title,
}: React.PropsWithChildren<TravelFormOverlayWrapperProps>) {
    return (
        <SlideUpOverlay
            onClose={onClose}
            title={title}
            titleStyle={'bold'}
        >
            {isLoading && <LoopedLoadingBar />}
            <div
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ paddingBottom: 'calc(80px + env(safe-area-inset-bottom, 0))' }}
            >
                {children}
            </div>
            {!isCtaHidden && (
                <div className={'travelFormOverlayWrapperSubmitButtonContainer fixed w-full bg-white z-2'}>
                    {typeof renderCtaText === 'string' ? (
                        <Button
                            disabled={isCtaDisabled}
                            onClick={onSubmit}
                            qaId={'qa-travel-form-overlay-submit-button'}
                            title={renderCtaText}
                        />
                    ) : (
                        <ButtonWrapper
                            disabled={isCtaDisabled}
                            onClick={onSubmit}
                            qaId={'qa-travel-form-overlay-submit-button'}
                        >
                            {renderCtaText}
                        </ButtonWrapper>
                    )}
                </div>
            )}
            <style jsx>{`
                .travelFormOverlayWrapperSubmitButtonContainer {
                    bottom: env(safe-area-inset-bottom, 0);
                    padding: 0 10px 20px 10px;
                }
                :global(body.fixed) .travelFormOverlayWrapperSubmitButtonContainer {
                    bottom: 0;
                }
            `}</style>
        </SlideUpOverlay>
    );
}
